import React, { useRef, useState } from 'react';
import { getBetDescription, getConfiguration, getToolTipDesc, hideTooltip, parseHandicap, showMatchDesc, showTooltip } from '../data/utils';
import { isOddUnderMinValue, useOddData } from './OddWrapper';
import { useHighlightOddChange } from './useHighlightOddChange';
import { ASIAN_HANDICAP, HANDICAP_TYPES_TO_SHOW_WITHOUT_HANDICAP } from '../data/constants';

export function getOddDesc(odd, noHandicap = false) {
    let desc = odd.desc;
    
    const betData = odd.betData;
    if (betData.hideHandicap) {
        desc = `${getBetDescription(betData, true)} ${odd.desc}`;
    } else if (showMatchDesc(odd)) {
        desc = getToolTipDesc(odd);
    } else {
        const conf = getConfiguration();
        if (!betData.calculateHandicapDescription || betData.handicap === 0 || HANDICAP_TYPES_TO_SHOW_WITHOUT_HANDICAP.includes(betData.tipoHandicap) || (conf.nas && ASIAN_HANDICAP.includes(betData.id))) {
            desc = odd.desc;
        }
    }

    if (!noHandicap) {
        if (odd.desc?.trim()?.length > 0) {
            const suffix = parseHandicap('', betData.handicap, betData.tipoHandicap, betData.eqs, betData.dia);
            if (suffix.length > 0 && suffix !== '0') {
                desc = `${odd.desc} (${suffix})`;
            }
        }
    }

    return desc;
}

export default function MoreBetsOdd(props) {
    const [tooltip, setTooltip] = useState(null);
    const oddContainer = useRef(null);
    
    useHighlightOddChange(oddContainer, props.value, props.matchData.isLive);

    const [, selected, addBet] = useOddData(props);
    const desc = getOddDesc(props, props.noHandicap);
    
    function handleMouseOver() {
        if (oddContainer.current) {
            const t = tooltip ? tooltip : getToolTipDesc(props);
            showTooltip(oddContainer.current, t);
            if (tooltip == null) {
                setTooltip(t);
            }
        }
    }
    function handleOnMouseOut() {
        hideTooltip();
    }
    
    let classes = '';
    if (selected) {
        classes += 'selezionata';
    }
    if (props.betData.pClass != null) {
        classes += ' ' + props.betData.pClass;
    }
    
    let matchDesc = null;
    if (props.tooltip && !props.isLastMinute && showMatchDesc(props)) {
        matchDesc = getToolTipDesc(props);
    }
    
    return <>
            {matchDesc ?
                <>
                    {props.value == null || isOddUnderMinValue(props.rawValue) ?
                        <div ref={oddContainer} className="bg-grigio-chiaro bordo-tondo quota quota-con-nome">
                            <span>{matchDesc}</span>
                            <i className="fa fa-lock"></i>
                        </div>
                        :
                        <div ref={oddContainer} className={"bg-grigio-chiaro bordo-tondo quota quota-con-nome " + classes} onClick={addBet} onMouseOver={handleMouseOver} onMouseOut={handleOnMouseOut}>
                            <span>{matchDesc}</span>
                            <span>{props.value}</span>
                        </div>
                    }
                </>
                :
                <>
                    {props.value == null || isOddUnderMinValue(props.rawValue) ?
                        <div ref={oddContainer} className="bg-grigio-chiaro bordo-tondo quota quota-con-nome">
                            <span>{desc}</span>
                            <i className="fa fa-lock"></i>
                        </div>
                        :
                        <div ref={oddContainer} className={"bg-grigio-chiaro bordo-tondo quota quota-con-nome " + classes} onClick={addBet} onMouseOver={handleMouseOver} onMouseOut={handleOnMouseOut}>
                            <span>{desc}</span>
                            <span>{props.value}</span>
                        </div>
                    }
                </>
            }
   </>

}
